module.exports = __webpack_public_path__ + "img/Icon - Locked.25770367.svg";